export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Brand.woff?ee8f27cf9188fc191d08f104f2eda0c9";